import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as IndirectRateRuleActions from './indirect-rate-rule.actions';
import { IndirectRateRule } from './indirect-rate-rule.model';

export const indirectRateRulesFeatureKey = 'indirectRateRules';

export interface State extends EntityState<IndirectRateRule> {
    // additional entities state properties
}

export const adapter: EntityAdapter<IndirectRateRule> =
    createEntityAdapter<IndirectRateRule>();

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const indirectRateRuleReducer = createReducer(
    initialState,
    on(IndirectRateRuleActions.addIndirectRateRule, (state, action) =>
        adapter.addOne(action.indirectRateRule, state)
    ),
    on(IndirectRateRuleActions.upsertIndirectRateRule, (state, action) =>
        adapter.upsertOne(action.indirectRateRule, state)
    ),
    on(IndirectRateRuleActions.addIndirectRateRules, (state, action) =>
        adapter.addMany(action.indirectRateRules, state)
    ),
    on(IndirectRateRuleActions.upsertIndirectRateRules, (state, action) =>
        adapter.upsertMany(action.indirectRateRules, state)
    ),
    on(IndirectRateRuleActions.updateIndirectRateRule, (state, action) =>
        adapter.updateOne(action.indirectRateRule, state)
    ),
    on(IndirectRateRuleActions.updateIndirectRateRules, (state, action) =>
        adapter.updateMany(action.indirectRateRules, state)
    ),
    on(IndirectRateRuleActions.deleteIndirectRateRule, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(IndirectRateRuleActions.deleteIndirectRateRules, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(IndirectRateRuleActions.loadIndirectRateRules, (state, action) =>
        adapter.setAll(action.indirectRateRules, state)
    ),
    on(IndirectRateRuleActions.clearIndirectRateRules, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return indirectRateRuleReducer(state, action);
}
